// extracted by mini-css-extract-plugin
module.exports = {"buttonPageLinks":"PageLinks_buttonPageLinks__3k2TF","notHighlightButtonPageLinks":"PageLinks_notHighlightButtonPageLinks__2hiAc"};